// extracted by mini-css-extract-plugin
export var legendIndicator = "_cd-1";
export var legendRight = "_cd-0";